"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinimumNoticeTimeBusyDays = exports.getConfiguredAvailabilityByDate = exports.getConfiguredBookableDates = exports.getTroubleshootStartTimesForSelectedDate = exports.getTroubleshootTimesForSelectedDurationByDay = exports.getTroubleshootTimesForSelectedDuration = exports.getTroubleshootTimesByDuration = exports.getConfiguredPossibleStartTimes = exports.getConfiguredAvailableTimeRanges = exports.isTroubleshootingSelector = exports.canTroubleshootSelector = exports.userLoggedInToValidPortal = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("transmute/get"));

var _immutable = require("immutable");

var _analytics = require("MeetingsLib/utils/analytics");

var _utils = require("MeetingsBase/utils/utils");

var _RESTParamSelectors = require("MeetingsLib/selectors/RESTParamSelectors");

var _TimeRangeListUtils = require("MeetingsBase/utils/TimeRangeListUtils");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _dates = require("MeetingsBase/constants/dates");

var _AvailabilityMilliseconds = _interopRequireDefault(require("MeetingsBase/models/AvailabilityMilliseconds"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var createSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _immutable.is);
var getTroubleshooting = (0, _get.default)('troubleshooting');
var shouldAllowTroubleshootMode = (0, _get.default)('allowTroubleshootMode');

var userLoggedInToValidPortal = function userLoggedInToValidPortal(state) {
  var portalIdFromUserProfile = (0, _get.default)('portalId', state);
  var portalIdFromLoginCookie = (0, _analytics.getHubSpotHubId)();
  return portalIdFromUserProfile && portalIdFromLoginCookie && "" + portalIdFromUserProfile === portalIdFromLoginCookie;
};

exports.userLoggedInToValidPortal = userLoggedInToValidPortal;
var canTroubleshootSelector = createSelector([_RESTParamSelectors.getEmbedded, _BookInfoSelectors.getOffline, shouldAllowTroubleshootMode, userLoggedInToValidPortal], function (embedded, offline, allowTroubleshootMode, loggedIn) {
  return !embedded && !offline && allowTroubleshootMode && loggedIn || false;
});
exports.canTroubleshootSelector = canTroubleshootSelector;
var isTroubleshootingSelector = createSelector([getTroubleshooting, canTroubleshootSelector], function (_ref, canTroubleshoot) {
  var troubleshootingActive = _ref.active;
  return troubleshootingActive && canTroubleshoot;
});
exports.isTroubleshootingSelector = isTroubleshootingSelector;
var getConfiguredAvailableTimeRanges = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getCustomParams, _RESTParamSelectors.getCurrentTime], function (troubleshooting, customParams, currentTime) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  return (0, _utils.getConfiguredAvailableTimeRanges)(_AvailabilityMilliseconds.default.fromAvailability(customParams.availability), customParams.weeksToAdvertise, customParams.customAvailabilityStartDate, customParams.customAvailabilityEndDate, customParams.timezone, currentTime);
});
exports.getConfiguredAvailableTimeRanges = getConfiguredAvailableTimeRanges;
var getConfiguredPossibleStartTimes = createSelector([_BookInfoSelectors.getStartTimeIntervalMilliseconds, getConfiguredAvailableTimeRanges, _BookInfoSelectors.getEvent], function (startTimeIntervalMilliseconds, configuredAvailableTimeRanges, event) {
  return (0, _TimeRangeListUtils.getFlexibleIntervalStartTimes)(configuredAvailableTimeRanges, event.duration, startTimeIntervalMilliseconds);
});
exports.getConfiguredPossibleStartTimes = getConfiguredPossibleStartTimes;
var getTroubleshootTimesByDuration = createSelector([getTroubleshooting], function (troubleshooting) {
  return (0, _getIn.default)(['data', 'troubleshootTimesByDuration'])(troubleshooting) || {};
});
exports.getTroubleshootTimesByDuration = getTroubleshootTimesByDuration;
var getTroubleshootTimesForSelectedDuration = createSelector([getTroubleshootTimesByDuration, _BookInfoSelectors.getMeetingLength], function (timesByDuration, duration) {
  return (0, _getIn.default)([duration, 'troubleshootTimes'])(timesByDuration) || (0, _immutable.List)();
});
exports.getTroubleshootTimesForSelectedDuration = getTroubleshootTimesForSelectedDuration;
var getTroubleshootTimesForSelectedDurationByDay = createSelector([getTroubleshootTimesForSelectedDuration, _BookInfoSelectors.getUserTimezone], function (troubleshootTimes, userTimezone) {
  return troubleshootTimes ? (0, _immutable.List)(troubleshootTimes).groupBy(function (troubleshootTime) {
    return _I18n.default.moment(troubleshootTime.startMillisUtc).tz(userTimezone).format('YYYY-MM-DD');
  }) : (0, _immutable.List)();
}); // Date selectors

exports.getTroubleshootTimesForSelectedDurationByDay = getTroubleshootTimesForSelectedDurationByDay;
var getTroubleshootStartTimesForSelectedDate = createSelector([getTroubleshootTimesForSelectedDurationByDay, _BookInfoSelectors.getEvent], function (troubleshootTimesForSelectedDurationByDay, event) {
  return troubleshootTimesForSelectedDurationByDay.get(event.dateString) || (0, _immutable.List)();
});
exports.getTroubleshootStartTimesForSelectedDate = getTroubleshootStartTimesForSelectedDate;
var getConfiguredBookableDates = createSelector([isTroubleshootingSelector, _BookInfoSelectors.getCustomParams, _RESTParamSelectors.getCurrentTime], function (troubleshooting, customParams, currentTime) {
  if (!troubleshooting) {
    return (0, _immutable.List)();
  }

  var weeksToAdvertise = customParams.weeksToAdvertise,
      customAvailabilityStartDate = customParams.customAvailabilityStartDate,
      customAvailabilityEndDate = customParams.customAvailabilityEndDate;
  return (0, _utils.getBookableDays)(weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, currentTime).map(function (startDayTimestamp) {
    return _I18n.default.moment.utc(startDayTimestamp).format('YYYY-MM-DD');
  });
});
exports.getConfiguredBookableDates = getConfiguredBookableDates;
var getConfiguredAvailabilityByDate = createSelector([getConfiguredPossibleStartTimes, _BookInfoSelectors.getUserTimezone], function (configuredPossibleStartTimes, userTimezone) {
  return configuredPossibleStartTimes.groupBy(function (startTime) {
    return _I18n.default.moment(startTime).tz(userTimezone).format('YYYY-MM-DD');
  });
});
exports.getConfiguredAvailabilityByDate = getConfiguredAvailabilityByDate;
var getMinimumNoticeTimeBusyDays = createSelector([_BookInfoSelectors.getCustomParams, _RESTParamSelectors.getCurrentTime], function (customParams, currentTime) {
  var minimumNoticeTime = customParams.minimumNoticeTime;

  if (minimumNoticeTime < _dates.ONE_DAY) {
    return (0, _immutable.List)();
  }

  var numberOfDays = Math.floor(minimumNoticeTime / _dates.ONE_DAY);
  var listOfDays = (0, _utils.getListOfDays)(_I18n.default.moment(currentTime), numberOfDays);
  return listOfDays.map(function (timestamp) {
    return _I18n.default.moment(timestamp).format('YYYY-MM-DD');
  });
});
exports.getMinimumNoticeTimeBusyDays = getMinimumNoticeTimeBusyDays;